import { IonIcon, IonItem } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { type Shift } from "@/lib/backend/api";
import { hourglassIcon } from "@/lib/icons/hourglass.icon";
import { ShiftApplicationDetails } from "../shift-application/shift-application-details";

type ShiftCardSimpleProps = {
  shift: Shift;
};

export function ShiftCardSimple({ shift }: ShiftCardSimpleProps) {
  const { t } = useTranslation();

  const startAt = new Date(shift.startAt).toLocaleString("nl-NL", {
    hour: "2-digit",
    minute: "2-digit",
  });
  const endAt = new Date(shift.endAt).toLocaleString("nl-NL", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <IonItem
      className="ion-no-padding w-full rounded-2xl bg-surface-primary text-md [--border-width:0] [--detail-icon-color:var(--ion-color-brand)] [--detail-icon-opacity:1] [--inner-padding-end:16px] [--padding-end:0] [--padding-start:0]"
      lines="none"
      style={{ "--background": "var(--ion-color-surface-primary)" }}
    >
      <Card className="w-full overflow-hidden border-none bg-surface-primary shadow-none">
        <CardContent className="p-4">
          <div className="flex flex-col gap-2">
            <div className="flex items-start justify-between">
              <h3 className="font-bold capitalize text-txt-brand">
                {new Date(shift.startAt).toLocaleDateString("nl-NL", {
                  weekday: "long",
                  day: "numeric",
                  month: "long",
                })}
              </h3>
              <IonIcon icon={hourglassIcon} className="size-5 text-brand-500" />
            </div>

            {/* <p className="text-txt-primary">{t("enums:shiftStatus.PENDING")}</p> */}
            <ShiftApplicationDetails
              label={t("entity:position.singular.capitalized")}
              labelValue={shift.position?.name}
              startTime={startAt}
              endTime={endAt}
            />
          </div>
        </CardContent>
      </Card>
    </IonItem>
  );
}
